export const ja = {
  ['%=']: '剰余代入',
  ['&=']: 'ビットごとの AND 代入',
  ['**=']: 'べき乗代入',
  ['()=>{}']: 'アローかんすうを作る',
  ['*=']: 'にかける',
  ['+=']: 'に足す',
  ['-=']: 'から引く',
  ['/=']: 'をわる',
  [':']: 'ギなら',
  ['<<=']: '左シフト代入',
  ['=']: 'に入れる',
  ['>>=']: '右シフト代入',
  ['>>>=']: '符号なし右シフト代入',
  ['?']: 'がシンなら',
  ['^=']: 'ビットごとの XOR 代入',
  ['as']: 'と名付ける',
  assignmentPattern: '省略時は',
  ['class{}']: 'クラスを作る',
  const: 'せんげんする',
  continue: 'くり返しをやめる',
  debugger: 'デバッガーを起動',
  ['do while']: 'シンならもう一度',
  extends: '継承する',
  false: 'ギ',
  ['function(){}']: 'かんすうを作る',
  idEnd: '」',
  idStart: '「',
  init: 'は',
  let: 'せんげんする',
  null: 'ヌル',
  object: 'オブジェクト',
  true: 'シン',
  undefined: 'アンディファインド',
  var: 'せんげんする',
  while: 'シンの間くり返す',
  ['|=']: 'ビットごとの OR 代入'
};
